<template>
  <div>
    <!--<div class="columns is-vcentered has-bg-light">
      <div class="column is-size-6 has-text-grey">
        <span class="has-text-weight-normal">Période de</span>
        <span class="has-text-grey is-underline has-text-weight-normal is-dotted"
              @click="openStartMonthPicker">{{startDateLabel}}</span>
        <datepicker id="startDatePicker" @selected="updateStartDate" v-model="rawStartDate" language="fr"
                    ref="startDatePicker" style="display: inline-block;"
                    :minimumView="'month'" :maximumView="'month'">
        </datepicker>
        <span class="has-text-weight-normal">à</span>
        <span class="has-text-grey is-underline has-text-weight-normal is-dotted"
              @click="openEndMonthPicker">{{endDateLabel}}</span>
        <datepicker id="endDatePicker" @selected="updateEndDate" v-model="rawEndDate" language="fr"
                    ref="endDatePicker"
                    :disabled="disabledDates"
                    :minimumView="'month'" :maximumView="'month'">
        </datepicker>
      </div>
    </div>-->
    <div class="has-bg-light">
      <div class="columns is-gapless">
        <div class="column is-4 is-3-fullhd is-border-right">
          <div class="field is-padding-left is-padding-right has-bg-lighter">
            <p class="control has-icons-left has-icons-right">
              <flat-pickr id="startDatePicker" :config="periodConfigDate"
                          v-model="rawStartDate"
                          @on-change="updateStartDate"
                          @on-close="resetPeriod"
                          class="input is-fullwidth is-borderless has-bg-lighter"
                          name="date">
              </flat-pickr>
              <span class="icon is-small is-left has-text-black">
                <i class="fal fa-calendar-alt is-size-4"></i>
              </span>
              <span class="icon is-large is-right has-text-dark">
                <i class="far fa-chevron-down is-size-7"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column is-4 is-3-fullhd is-border-right">
          <div class="field is-padding-left is-padding-right has-bg-lighter">
            <p class="control has-icons-left has-icons-right">
              <flat-pickr id="endDatePicker" :config="periodConfigDate"
                          v-model="rawEndDate"
                          @on-close="resetPeriod"
                          @on-change="updateEndDate"
                          class="input is-fullwidth is-borderless has-bg-lighter"
                          name="date">
              </flat-pickr>
              <span class="icon is-small is-left has-text-black">
                <i class="fal fa-calendar-alt is-size-4"></i>
              </span>
              <span class="icon is-large is-right has-text-dark">
                <i class="far fa-chevron-down is-size-7"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column is-4 is-3-fullhd is-padding-left is-padding-right has-bg-lighter">
          <div class="select is-fullwidth">
            <select id="period" @change="setCustomPeriod" v-model="period" class="is-borderless">
              <option :value="null">Périodes</option>
              <option v-for="period in periods" :value="period">{{period.label}}</option>
            </select>
          </div>
        </div>
        <div class="column is-hidden-desktop-only is-hidden-widescreen-only is-border-left">
        </div>
      </div>
    </div>
    <div class="columns is-multiline is-border-top">
      <div class="column is-4 is-border-right is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Total ventes CA</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-3 has-text-weight-medium">{{stats.CA | prettyPrice}} {{$currency}}
            <sup v-if="showfakeStats" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup v-else-if="evoCA" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success"
                 :class="evoCA > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="evoCA" class="is-marginless is-size-5" :class="evoCA > 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoCA > 0">+ </span>{{evoCA | prettyPrice}} {{$currency}}
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-right is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Prix ventes moyen</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">{{stats.avgCA | prettyPrice}} {{$currency}}
            <sup v-if="showfakeStats" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup v-else-if="evoAvgCA" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success"
                 :class="evoAvgCA > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 16 545 {{$currency}}
          </div>
          <div v-else-if="evoAvgCA" class="is-marginless is-size-7"
               :class="evoAvgCA > 0 ? 'has-text-success' : 'has-text-danger'">
            <span v-if="evoAvgCA && evoAvgCA > 0">+ </span>{{evoAvgCA | prettyPrice}} {{$currency}}
          </div>
        </div>
      </div>
      <div class="column is-4  columns is-column is-space-between"
           v-if="sourceRdvs.length && !sourceUser.is_external">
        <div class="has-text-grey">Nombre de RDV</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">{{sourceRdvs.length}}</div>
          <div class="is-marginless is-size-7 has-text-success" v-if="(evoAvgCA && evoAvgCA > 0) || evoCA > 0">&nbsp;
          </div>
        </div>
      </div>
      <div class="column is-4 columns is-column is-space-between" v-else></div>
      <div class="column is-4 is-border-top is-border-right is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Nombre de réservations</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">{{stats.reservationsCount}}
            <sup v-if="showfakeStats" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup v-else-if="evoReservationCount" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success"
                 :class="evoReservationCount > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 6
          </div>
          <div v-else class="is-marginless is-size-7 has-text-success">
            <span v-if="evoReservationCount && evoReservationCount > 0">+ </span>{{evoReservationCount}}
          </div>
        </div>
      </div>
      <div class="column is-4 is-border-top is-border-right is-border-dashed columns is-column is-space-between">
        <div class="has-text-grey">Nombre d'actes</div>
        <div class="is-margin-top-large">
          <div class="is-marginless is-size-4 has-text-weight-medium">
            <span v-if="showfakeStats">14</span>
            <span v-else>{{stats.actesCount}}</span>
            <sup v-if="showfakeStats" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup v-else-if="evoSalesCount" class="is-size-5">
              <i class="fal fa-arrow-right"
                 :class="evoSalesCount > 0 ? 'is-rotate-315 has-text-success' : 'is-rotate-45 has-text-danger'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 4
          </div>
          <div v-else class="is-marginless is-size-7 has-text-danger">
            <span v-if="evoSalesCount && evoSalesCount > 0">+ </span>{{evoSalesCount}}
          </div>
        </div>
      </div>
      <div v-if="!sourceUser.is_external"
           class="column is-4 columns is-column is-space-between is-border-top is-border-dashed">
        <div class="has-text-grey">Taux de transformation Actes / RDV</div>
        <div class="is-margin-top-large">
          <span v-if="showfakeStats">66%</span>
          <span v-else style="display: none;">{{stats.actesCount}} / {{pastRdvsWithoutR0.length}}</span>
          <div class="is-marginless is-size-4 has-text-weight-medium">{{txRdvActed}}
            <sup v-if="showfakeStats" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success is-rotate-315"></i>
            </sup>
            <sup v-if="evoTxRdvActed" class="is-size-5">
              <i class="fal fa-arrow-right has-text-success"
                 :class="evoTxRdvActed > 0 ? 'is-rotate-315 has-text-danger' : 'is-rotate-45 has-text-success'"></i>
            </sup>
          </div>
          <div v-if="showfakeStats" class="is-marginless is-size-7 has-text-success">
            + 25 %
          </div>
          <div v-if="evoTxRdvActed" class="is-marginless is-size-7"
               :class="evoTxRdvActed > 0 ? 'has-text-danger' : 'has-text-succes'">
            <span v-if="evoTxRdvActed > 0">+ </span>{{evoTxRdvActed}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { StatsMx, StatsPeriodMx } from '@/mixins'
  import moment from 'moment'
  import { debounce } from 'lodash'

  export default {
    name: 'UserSalesPane',
    mixins: [StatsMx, StatsPeriodMx],
    data () {
      return {
        entityKey: 'USER',
        rawStartDate: null,
        rawEndDate: null
      }
    },
    props: {
      sales: {
        type: Array,
        required: true
      },
      previousSales: {
        type: Array,
        required: false
      },
      sourceUser: {
        type: Object,
        required: true
      },
      sourceRdvs: {
        type: Array,
        default: () => []
      },
      startDate: {
        type: [Object, Date],
        required: true
      },
      endDate: {
        type: [Object, Date],
        required: true
      }
    },
    computed: {
      showfakeStats () {
        return JSON.parse(this.$configs.FAKE_STATS) === 1
      },
      evoCA () {
        if (this.stats.CA && this.previousStats && this.previousStats.CA) {
          return this.stats.CA - this.previousStats.CA
        } else {
          return null
        }
      },
      evoAvgCA () {
        if (this.stats.avgCA && this.previousStats && this.previousStats.avgCA) {
          return this.stats.avgCA - this.previousStats.avgCA
        } else {
          return null
        }
      },
      evoSalesCount () {
        if (this.stats.salesCount && this.previousStats && this.previousStats.salesCount) {
          return this.stats.salesCount - this.previousStats.salesCount
        } else {
          return null
        }
      },
      evoActesCount () {
        if (this.stats.salesCount && this.previousStats && this.previousStats.salesCount) {
          return this.stats.salesCount - this.previousStats.salesCount
        } else {
          return null
        }
      },
      pastRdvsWithoutR0 () {
        return this.sourceRdvs.filter(x => moment(x.date).format('x') < moment().format('x') && !['R0', 'EVENEMENT'].includes(x.rdv_type))
      },
      txRdvActed () {
        if (this.stats.actesCount && this.pastRdvsWithoutR0 && this.pastRdvsWithoutR0.length) {
          return ((this.stats.actesCount / this.pastRdvsWithoutR0.length) * 100).toFixed(2) + ' %'
        } else {
          return null
        }
      },
      previousPastRdvsWithoutR0 () {
        return this.previousRdvs.filter(x => !['R0', 'EVENEMENT'].includes(x.rdv_type))
      },
      evoTxRdvActed () {
        if (this.previousStats && this.previousStats.salesCount && this.previousPastRdvsWithoutR0 && this.previousPastRdvsWithoutR0.length) {
          return ((this.previousStats.salesCount / this.previousPastRdvsWithoutR0.length) * 100).toFixed(2) + ' %'
        } else {
          return null
        }
      },
      evoReservationCount () {
        if (this.stats.reservationsCount && this.previousStats && this.previousStats.reservationsCount) {
          return this.stats.reservationsCount - this.previousStats.reservationsCount
        } else {
          return null
        }
      },
      stats () {
        return this.computedSalesData(this.sales)
      },
      previousStats () {
        if (this.previousSales) {
          return this.computedSalesData(this.previousSales)
        }
        return null
      },
      entityPk () {
        return this.sourceUser.pk
      },
      endDateLabel () {
        return moment(this.endDate).format('DD MMMM YYYY')
      },
      startDateLabel () {
        return moment(this.startDate).format('DD MMMM YYYY')
      },
      disabledDates () {
        return {
          to: moment(this.rawStartDate).toDate()
        }
      }
    },
    methods: {
      /* openStartMonthPicker () {
        this.$refs.startDatePicker.showCalendar()
      },
      openEndMonthPicker () {
        this.$refs.endDatePicker.showCalendar()
      }, */
      updateStartDate (dates) {
        console.log('updateStartDate')
        let startDate = moment(dates[0])
        let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        if (startDate.isAfter(endDate)) {
          this.rawEndDate = startDate.endOf('month').toDate()
        }
        this.updateData()
      },
      updateEndDate (d) {
        // this.rawEndDate = d
        this.updateData()
      },
      updateData: debounce(function () {
        // let startDate = moment(this.rawStartDate, 'YYYY-MM-DD')
        // let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        this.$emit('reloadSalesData', { startDate: this.rawStartDate, endDate: this.rawEndDate })
      }, 300)
    },
    created () {
      this.initPeriods()
      // this.rawStartDate = moment().startOf('year').toDate()
      this.rawStartDate = moment(this.startDate).toDate()
      // this.rawEndDate = moment().endOf('month').toDate()
      this.rawEndDate = moment(this.endDate).toDate()
    },
    mounted () {}
  }
</script>

<style>
  #startDatePicker, #endDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/UserStatsPane.vue